import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { CdkTableModule } from "@angular/cdk/table";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DateService } from "./services/date.service";
import { GeneralService } from "./services/general.service";
//import {RatingModule} from "ngx-rating";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { LoginComponent } from "./login/login.component";
import { MenuComponent } from "./menu/menu.component";
import { IndexComponent } from "./index/index.component";
import { ArticleComponent } from "./article/article.component";
import { CategorieComponent } from "./categorie/categorie.component";
import { CaracteristiqueComponent } from "./caracteristique/caracteristique.component";
import { ListeArticlesComponent } from "./liste-articles/liste-articles.component";
import { RechercheComponent } from "./recherche/recherche.component";
import { ModelCaracteristiqueComponent } from "./model-caracteristique/model-caracteristique.component";
import { ShowTreeDocComponent } from "./show-tree-doc/show-tree-doc.component";
import { GroupeCategorieComponent } from "./groupe-categorie/groupe-categorie.component";
import { ShowModelComponent } from "./show-model/show-model.component";
import { BanniereComponent } from "./banniere/banniere.component";
import { RechercheModalComponent } from "./recherche-modal/recherche-modal.component";
import { MarqueComponent } from "./marque/marque.component";
import { ListeComponent } from "./liste/liste.component";
import { ListeValeurCaracteristiqueModalComponent } from "./liste-valeur-caracteristique-modal/liste-valeur-caracteristique-modal.component";
import { LinkComponentComponent } from "./link-component/link-component.component"; //13/11/2019
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ContentManagerComponent } from "./content-manager/content-manager.component";
import { EquipeTravailComponent } from "./equipe-travail/equipe-travail.component";
import { BloguesComponent } from "./blogues/blogues.component";
import { ListeCommandesComponent } from "./liste-commandes/liste-commandes.component";
import { InstagramComponent } from "./instagram/instagram.component";
import { AppRoutingModule } from "./app-routing.module";
import { FilterPerAnykeyPipe } from "./pipes/filter-per-anykey.pipe";
import { ReferencementComponent } from './referencement/referencement.component';
import { TextPipePipe } from "./pipes/text-pipe.pipe";
import { SettingsComponent } from './settings/settings.component';
import { AccessToSettingsComponent } from './access-to-settings/access-to-settings.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MenuComponent,
    IndexComponent,
    ArticleComponent,
    CategorieComponent,
    CaracteristiqueComponent,
    ListeArticlesComponent,
    RechercheComponent,
    ModelCaracteristiqueComponent,
    ShowTreeDocComponent,
    GroupeCategorieComponent,
    ShowModelComponent,
    BanniereComponent,
    RechercheModalComponent,
    MarqueComponent,
    ListeComponent,
    ListeValeurCaracteristiqueModalComponent,
    LinkComponentComponent,
    ContentManagerComponent,
    EquipeTravailComponent,
    BloguesComponent,
    ListeCommandesComponent,
    InstagramComponent,
    FilterPerAnykeyPipe,
    TextPipePipe,
    ReferencementComponent,
    SettingsComponent,
    AccessToSettingsComponent
  ],
  imports: [
    AppRoutingModule,
    RouterModule,
    FlexLayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatTabsModule,
    MatSelectModule,
    MatTreeModule,
    MatCheckboxModule,
    MatListModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatSortModule,
    MatTooltipModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatStepperModule,
    FormsModule,
    CdkTableModule,
    HttpClientModule,
    //RatingModule,
    CKEditorModule,
    MatProgressSpinnerModule,
    AngularEditorModule,
  ],
  providers: [DateService, GeneralService],
  bootstrap: [AppComponent],
})
export class AppModule {}
